<template>
  <div class="training-questions-page">
    <app-page-header
      :title="[training ? training.title : 'Treinamentos', 'Perguntas']"
      :loading="isLoading"
    >
      <router-link
        :to="{ name: 'trainings.questions.create', params: { trainingId } }"
        tag="button"
        type="button"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="plus"></b-icon>Novo
      </router-link>
      <button type="button" v-app-button.icon-left.clear v-app-back-button="{ name: 'trainings.index' }">
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>

    <training-questions-table
      :trainingId="trainingId"
    ></training-questions-table>
  </div>
</template>

<script>
import TrainingService from '@/services/training.service';
import TrainingQuestionsTable from '@/components/Tables/TrainingQuestionsTable.vue';

export default {
  name: 'questions',
  components: {
    TrainingQuestionsTable,
  },
  data: () => {
    return {
      isLoading: true,
      trainingId: null,
      training: null,
    };
  },
  methods: {
    loadTraining(id) {
      TrainingService.getId(id)
        .then(({ data: training }) => (this.training = training))
        .finally(() => (this.isLoading = false));
    },
  },
  beforeMount() {
    this.trainingId = this.$route.params.trainingId;
    this.loadTraining(this.trainingId);
  },
};
</script>
